// extracted by mini-css-extract-plugin
export default {"privacy":"privacy_privacy__j7-1R","h2":"privacy_h2__MV+At","h3":"privacy_h3__cPdFa","p":"privacy_p__ttEUL"};